import { TextUtils } from '../../../resources/text.utils';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[DocMask]',
})
export class DocMaskDirective {
    @Input() public maskOption;
    @Input() public padValue: number|string;
    @Input() public padLength: number;
    @Input() public padPosition: 'start'|'end';
    @Input('DocMask') public formControl: FormControl;

    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        private control: NgControl,
        private textUtils: TextUtils,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    @HostListener('input', ['$event'])
    public onEvent($event) {
        this.control.control.setValue(this.formatValue(this.nativeElement.value));
    }

    @HostListener('focusout', ['$event'])
    public onFocusout($event) {
        if (this.padValue) {
            this.control.control.setValue(this.padFormValue(this.nativeElement.value));
        }
    }

    private formatValue(value: string) {

        switch (this.maskOption) {
            case 'cpf':
                return VMasker.toPattern( value, '999.999.999-99' );

            case 'onlyNumbers':
                return VMasker.toNumber( value ); // não existe padrão de RG, cada estado utiliza uma máscara diferente

            case 'cep':
                return VMasker.toPattern( value, '99.999-999' );

            case 'cnpj':
                return VMasker.toPattern( value, '99.999.999/9999-99' );

            case 'cpf-cnpj':
                return VMasker.toPattern( value, value.length <= 11 ? '999.999.999-99?9' : '99.999.999/9999-99' );
        }

    }

    /**
     * Formata o valor do formulário inserindo um caracter definido no inicio ou no final da string
     * @param value - valor do formulário
     */
    private padFormValue(value: string): string {
        if (this.padValue && this.padLength) {
            switch (this.padPosition) {
                case 'start': {
                    return this.textUtils.padStart(this.nativeElement.value, this.padValue.toString(), this.padLength);
                }
                case 'end': {
                    return this.textUtils.padEnd(this.nativeElement.value, this.padLength, this.padValue.toString());
                }
            }
        }

        return value;
    }
}
